import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getImageStylesAndSrc } from './helpers';
import ImgZoomable from './ImageZoomable';
import Img from './ImageBase';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MatureContext } from '@wix/da-react-context/pkg/MatureContext';
import HiddenDumbView from '../../../../DeviationViews/Dumbo/Hidden';
import isNumber from 'lodash/isNumber';
import { ViewerContainerSizeContext } from '../../../ViewerContainerSizeContext/ViewerContainerSizeContext';
const ImageView = (props)=>{
    const containerWidth = useContext(ViewerContainerSizeContext);
    const { deviation , width: propsWidth , config  } = props;
    const showMatureContent = useContext(MatureContext);
    const { isLoggedIn  } = useContext(SessionContext);
    let configuredWidth = propsWidth;
    if (config.width && propsWidth) {
        configuredWidth = config.width < propsWidth ? config.width : propsWidth;
    }
    if (!showMatureContent && deviation.isMature || deviation.isBlocked || deviation.isAntisocial && !isLoggedIn) {
        // We have extra check for anti-social because inside a saved editor
        // deviation we can have stale isBlocked value
        return /*#__PURE__*/ React.createElement(HiddenDumbView, _extends({}, props, {
            width: isNumber(configuredWidth) ? configuredWidth : 780
        }));
    }
    const calculatedProps = getImageStylesAndSrc(deviation, configuredWidth, config, containerWidth);
    if (!calculatedProps) {
        return null;
    }
    const { allowFullview , canBeLinked , wrapperStyles , coverThumb , imgStyles  } = calculatedProps;
    const ImageComponent = allowFullview && !canBeLinked ? ImgZoomable : Img;
    return /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        className: classnames(getThumbGlobalClassNames(deviation)),
        style: wrapperStyles,
        link: config.link,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(ImageComponent, {
        file: coverThumb,
        deviation: deviation,
        imgStyles: imgStyles
    }));
};
ImageView.displayName = 'ImageView';
export default ImageView;
